import { APIBlobResponse } from "../../../models/NetworkResponse";
import { downloadFileFromServer } from "../../../api/Networking";

const VENDOR_SECURE_DOWNLOAD_HOST = "content-vendorpartner.swageazy.com";
const VENDOR_DOCUMENT_BUCKET = "vendor-dashboard-portal";

export namespace HelperAPI {
  export const downloadAFile = async (
    url?: string,
    container?: string,
    filename?: string,
  ): Promise<APIBlobResponse> => {
    try {
      if (url && url.includes("https://") && url.length > 0) {
        const response = await downloadFileFromServer(url, null, null);
        return response;
      } else if (
        container &&
        filename &&
        container.length > 0 &&
        filename.length > 0 &&
        container.length > 0
      ) {
        const response = await downloadFileFromServer(
          null,
          container,
          filename,
        );
        return response;
      } else {
        throw new Error("URL, container, and filename are required");
      }
    } catch (error) {
      throw error;
    }
  };

  export const downloadVendorFiles = async (
    fileUrl: string,
    defaultFilename: string | null,
  ): Promise<void> => {
    if (!fileUrl || fileUrl.trim() === "") return;

    const url = new URL(fileUrl);
    const useSecureApi = url.host === VENDOR_SECURE_DOWNLOAD_HOST;

    const { data, filename } = await downloadFileFromServer(
      fileUrl,
      null,
      null,
      useSecureApi ? VENDOR_DOCUMENT_BUCKET : null,
    );

    if (data) {
      const blobUrl = window.URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename || defaultFilename || "download";
      link.click();
      window.URL.revokeObjectURL(blobUrl);
    }
    return;
  };
}
